import React, { useEffect } from 'react';
import { Button, Form, Input, Space, Tooltip, message } from 'antd';
import { MinusCircleOutlined, PlusOutlined, QuestionCircleOutlined } from '@ant-design/icons';
import { useTranslation } from '../../../../shared/i18n';
import tmService from '../../../services/tmService';
import { ok, toastErr } from './common';

/** 营销流设置：实体地址（必填）、类别（退订按类别；声明后发信只接受这些类别）。追踪开关在「设置」 */
const Marketing = ({ stream, onSaved }) => {
    const { t } = useTranslation();
    const [form] = Form.useForm();
    const [saving, setSaving] = React.useState(false);

    useEffect(() => {
        form.setFieldsValue({
            postal_address: stream.postal_address || '',
            categories: stream.categories || [],
        });
    }, [stream, form]);

    const save = async () => {
        const v = await form.validateFields();
        setSaving(true);
        try {
            const r = await tmService.updateStream(stream.id, {
                postal_address: v.postal_address.trim(),
                categories: (v.categories || []).filter((c) => c && c.code).map((c) => ({ code: c.code.trim(), name: (c.name || c.code).trim() })),
            });
            if (ok(r)) { message.success(t('Saved')); onSaved && onSaved(r.data); }
        } catch (e) {
            toastErr(e, t('Failed to save'));
        } finally {
            setSaving(false);
        }
    };

    return (
        <Form form={form} layout="vertical" style={{ maxWidth: 640 }}>
            <Form.Item name="postal_address" rules={[{ required: true, whitespace: true, message: t('Enter the sender\'s postal address') }]}
                label={<Space size={4}>{t('Sender postal address')}<Tooltip title={t('Added automatically to the footer of marketing emails')}><QuestionCircleOutlined /></Tooltip></Space>}>
                <Input.TextArea rows={2} maxLength={500} />
            </Form.Item>
            <Form.Item label={<Space size={4}>{t('Email categories')}<Tooltip title={t('Recipients can unsubscribe per category; once declared, every send\'s category must be one of these')}><QuestionCircleOutlined /></Tooltip></Space>}>
                <Form.List name="categories">
                    {(fields, { add, remove }) => (
                        <>
                            {fields.map(({ key, name }) => (
                                <Space key={key} align="baseline" style={{ display: 'flex', marginBottom: 4 }}>
                                    <Form.Item name={[name, 'code']} style={{ marginBottom: 0 }}
                                        rules={[{ required: true, message: t('Required') }, { pattern: /^[A-Za-z0-9_.-]{1,64}$/, message: t('Letters, digits, . _ -') }]}>
                                        <Input placeholder="newsletter" style={{ width: 160 }} />
                                    </Form.Item>
                                    <Form.Item name={[name, 'name']} style={{ marginBottom: 0 }}>
                                        <Input placeholder={t('Display name')} style={{ width: 200 }} maxLength={64} />
                                    </Form.Item>
                                    <MinusCircleOutlined onClick={() => remove(name)} />
                                </Space>
                            ))}
                            <Button type="dashed" size="small" icon={<PlusOutlined />} onClick={() => add({ code: '', name: '' })}>{t('Add category')}</Button>
                        </>
                    )}
                </Form.List>
            </Form.Item>
            <div><Button type="primary" loading={saving} onClick={save}>{t('Save')}</Button></div>
        </Form>
    );
};

export default Marketing;
